/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { Typography, Button, Grid } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Navbar from "../../components/Navbar";
import error from "../../assets/images/payment.png";
import CloseIcon from "@mui/icons-material/Close";

export default function PaymentFailure() {
  const navigate = useNavigate();
  const offline_invoice_no = useSelector(
    (state) => state?.cartReducer?.offline_invoice_no
  );
  return (
    <>
      <Grid style={{ height: "100vh" }}>
        {/* <Navbar cart />
        <Grid
          container
          justifyContent="center"
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            padding: "0.8rem",
            boxShadow: "0px 0px 9px",
            background: "white",
          }}
        >
          <Typography variant="h5" style={{ fontWeight: "bold" }}>
          Payment
            Failed
          </Typography>
        </Grid> */}
        <Grid
          container
          justifyContent="center"
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{ paddingTop: "10rem" }}
        >
          <h3
            style={{
              fontFamily: "Satoshi",
              fontWeight: "900",
              marginBottom: "0rem",
              color: "#b51515",
            }}
          >
            Retry Payment
          </h3>
          <Grid container justifyContent="center" style={{ margin: "1rem" }}>
            <img src={error} style={{ width: "45%" }}></img>
          </Grid>
          <Typography>
            <Typography style={{ marginTop: "1rem", fontFamily: "Satoshi" }}>
              The payment didn't go through !!
            </Typography>
            {offline_invoice_no && (
              <Typography
                style={{
                  marginTop: "0.5rem",
                  fontFamily: "Satoshi",
                  fontSize: "0.9rem",
                  color: "#4B4A4B",
                  textAlign: "center",
                }}
              >
                offline-invoice-no: {offline_invoice_no}
              </Typography>
            )}
          </Typography>
          <Grid
            style={{
              left: "0px",
              position: "fixed",
              right: "0px",
              bottom: "0px",
              padding: "1.4rem",
              margin: "0px 0px",
              borderRadius: "2rem 2rem 0rem 0rem",
            }}
          >
            <Grid
              container
              justifyContent="space-evenly"
              style={{ paddingTop: "2rem" }}
            >
              <Button
                style={{
                  fontSize: "1.3rem",
                  borderRadius: "1rem",
                  minWidth: "100%",
                  color: "white",
                  padding: "1rem",
                  backgroundColor: "black",
                }}
                variant="contained"
                onClick={() => navigate("/checkout")}
              >
                Try Again
              </Button>
              <Button
                style={{
                  fontSize: "1.1rem",
                  borderRadius: "1rem",
                  minWidth: "100%",
                  color: "black",
                  padding: "0.8rem",
                  marginTop: "0.8rem",
                  backgroundColor: "white",
                  border: "1px solid black",
                }}
                variant="contained"
                onClick={() => navigate("/payment-ack")}
              >
                Check Payment Status
              </Button>
              {/* <Button
                style={{
                  borderRadius: "0.6rem",
                  padding: "0rem 2rem",

                  color: "black",
                }}
                variant="contained"
                onClick={() => navigate("/cart")}
              >
                Close
              </Button> */}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
